import React, { Component } from "react";
import {
  Container,
  Header,
  Icon,
  Grid,
  Button,
  Form,
  Image,
  Input,
  Checkbox,
  Table,
  Dropdown,
} from "semantic-ui-react";
import estimatePDFDownload from "../pdf/estimatePDFDownload";
import estimatePDFDownloadOneSheet from "../pdf/estimatePDFDownloadOneSheet";
import { hashHistory } from "react-router";

import Roundy from "../../services/roundy";
import moment from "moment";
import "./estimate.css";
class Estimator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      doublepage: true,
      estimate: {
        projmanager: null,
        status: "Not Approved",
        tja: "N/A",
        sow: "",
        sowNumber: null,
        description: "",
        poNumber: "",
        poItemNumber: "",
        creator: "",
        date: props.today,
        workOrderNbr: props.nextwon,
        program: "",
        scopeOfWorkSummary: "",
        scope: "",
        standardWork: "None",
        total: null,
        tasks: [],
        deliverables: [],
      },
      newtask: {},
      newdeliverable: {},
    };
  }
  componentDidUpdate(prevProps, prevState) {
    console.log(this.props.editmode);
    // this.populateState();
  }
  componentDidMount() {
    this.populateState();
  }
  componentWillUnmount() {
    console.log("Component Unmounting")
    window.localStorage.setItem("newestimate", JSON.stringify(this.state.estimate))
  }
  populateform(projmanager, project) {
    this.setState({
      projmanager,
      project,
    });
  }
  talytask() {
    let newtasks = this.state.estimate.tasks;
    for (var i = 0; i < newtasks.length; i++) {
      newtasks[i].number = i + 1;
    }
    this.setState({
      tasks: newtasks,
    });
  }
  talydeliv() {
    let newdelivs = this.state.estimate.tasks;
    for (var i = 0; i < newdelivs.length; i++) {
      newdelivs[i].number = i + 1;
    }
    this.setState({
      estimate: {
        ...this.state.estimate,
        deliverables: newdelivs,
      },
    });
  }
  handledeletetask(key) {
    let taskdelete = this.state.estimate.tasks;
    taskdelete.splice(key, 1);
    //estimate: { ...this.state.estimate, tasks: taskdelete }
    this.setState({
      estimate: {
        ...this.state.estimate,
        tasks: taskdelete,
      },
    });

    this.talytask();
  }
  handledeletedeliv(key) {
    let delivdelete = this.state.estimate.deliverables;
    delivdelete.splice(key, 1);

    this.setState({
      estimate: {
        ...this.state.estimate,
        deliverables: delivdelete,
      },
    });
    this.talydeliv();
  }
  saveEstimate() {
    window.localStorage.setItem('newEstimate', JSON.stringify(this.state.estimate))
  }
  geneditcheck() {
    if (this.props.approval || this.props.editmode) {
      return (
        <div>
          <Checkbox
            primary
            toggle
            onChange={() => this.props.changeModes()}
            checked={this.props.approval}
            label={this.props.approval ? "Approval" : "Modify"}
          />
          <Checkbox
            id="checkbox"
            toggle
            onChange={() =>
              this.setState({
                doublepage: !this.state.doublepage,
              })
            }
            checked={this.state.doublepage}
            label={this.state.doublepage ? "Two Pages" : "One Page"}
          />
          <Button
            icon
            primary
            id="printbtn"
            onClick={() => {
              if (this.state.doublepage) {
                estimatePDFDownload({
                  ...this.state.estimate,
                  billing: this.props.billing,
                });
              } else {
                estimatePDFDownloadOneSheet({
                  ...this.state.estimate,
                  billing: this.props.billing,
                });
              }
            }}
          >
            <Icon name="print" />
          </Button>
          {this.wodbutton()}
        </div>
      );
    }
  }
  handlesavebtn() {
    if (this.props.create) {

      return (
        <Button
          positive
          size="mini"
          onClick={() => {
            console.log("sending estimate", this.state.estimate);
            this.props.handlesave(this.state.estimate);
          }}
        >
          <Icon name="checkmark" /> Create Estimate
        </Button>
      );

    } else if (this.props.editmode) {
      return (
        <Button
          positive
          size="mini"
          onClick={() => {
            this.props.handlesave(this.state.estimate);
          }}
        >
          <Icon name="checkmark" />
          Update
        </Button>
      );
    } else if (this.props.approval) {
      return (
        <Button
          positive
          disabled={
            this.props.estimate.edfapprover || !this.props.myinfo.hradmin
          }
          size="mini"
          onClick={() => {
            this.props.handleapprove();
          }}
        >
          <Icon name="checkmark" />
          {this.props.estimate.edfapprover ? <Icon name="checkmark" /> : ""}
          {this.props.estimate.edfapprover
            ? "Approved by " + this.props.estimate.edfapprover
            : "Approve"}
        </Button>
      );
    }
  }
  gendeletebutton() {
    if (this.state.estimate.tasks.length !== 0) {
      return (
        <Dropdown
          text="Remove Task"
          floating
          labeled
          disabled={this.props.approval}
          button
          upward
          compact
          className="icon"
          color="orange"
          icon="minus square"
        >
          <Dropdown.Menu> {this.gendeletetasklist()} </Dropdown.Menu>
        </Dropdown>
      );
    }
  }
  gendeletedelivbutton() {
    if (this.state.estimate.deliverables.length !== 0) {
      return (
        <Dropdown
          text="Remove Deliverable"
          floating
          labeled
          button
          disabled={this.props.approval}
          upward
          compact
          className="icon"
          color="orange"
          icon="minus square"
        >
          <Dropdown.Menu> {this.gendeletedelivlist()} </Dropdown.Menu>
        </Dropdown>
      );
    }
  }

  gentotalhours() {
    if (this.state.estimate.tasks.length) {
      let total = this.state.estimate.tasks.reduce(
        (a, b) => a + parseFloat(b.hours),
        0
      );
      total = Roundy(parseFloat(total), false);
      // return Roundy(total);
      return total;
    } else {
      return 0;
    }
  }
  gensubtotal() {
    if (this.state.estimate.tasks.length) {
      let total = this.state.estimate.tasks.reduce(
        (a, b) => a + parseFloat(b.subtotal),
        0
      );
      // return Roundy(total);
      total = Roundy(parseFloat(total));
      return parseFloat(total).toFixed(2);
    } else {
      return 0;
    }
  }
  gendeletetasklist() {
    return this.state.estimate.tasks.map((task, index) => {
      return (
        <Dropdown.Item onClick={() => this.handledeletetask(index)}>
          {"Task: " + task.number}
        </Dropdown.Item>
      );
    });
  }
  gendeletedelivlist() {
    return this.state.estimate.deliverables.map((deliv, index) => {
      return (
        <Dropdown.Item onClick={() => this.handledeletedeliv(index)}>
          {"Deliverable: " + deliv.number}
        </Dropdown.Item>
      );
    });
  }
  updateTask(key, index, value) {
    let temptasks = Array.from(this.state.estimate.tasks);
    let temptask = temptasks[index];
    console.log("updating task", key);
    temptask = {
      ...temptasks[index],
      [key]: value,
    };
    if (parseFloat(temptask.hours) && parseFloat(temptask.rate)) {
      temptask.subtotal = Roundy(
        parseFloat(temptask.hours) * parseFloat(temptask.rate)
      );
    } else {
      temptask.subtotal = "FixHrs";
    }

    temptasks[index] = temptask;
    this.setState({
      estimate: {
        ...this.state.estimate,
        tasks: temptasks,
      },
    });
  }
  gentask() {
    if (this.state.estimate.tasks.length > 0) {
      return this.state.estimate.tasks.map((task, index) => {
        let subtotal = task.rate * task.hours;
        subtotal = Roundy(subtotal);

        if (!this.state.taskadd) {
          return (
            <Table.Row>
              <Table.Cell width={1}> {task.item} </Table.Cell>
              <Table.Cell width={6}> {task.description} </Table.Cell>
              <Table.Cell width={1}> {task.hours} </Table.Cell>
              <Table.Cell width={1}> $ {task.rate} </Table.Cell>
              <Table.Cell width={1}>
                {" "}
                $ {parseFloat(subtotal).toFixed(2)}{" "}
              </Table.Cell>
            </Table.Row>
          );
        } else if (this.state.taskadd) {
          let newtasks = this.state.estimate.tasks;

          return (
            <Table.Row>
              <Table.Cell width={1}> {task.item} </Table.Cell>
              <Table.Cell width={4}>
                <Input
                  ref="newdesc"
                  transparent
                  fluid
                  size="small"
                  value={this.state.estimate.tasks[index].description}
                  onChange={(e) => {
                    newtasks[index].description = e.target.value;
                    this.setState({
                      tasks: newtasks,
                    });
                  }}
                />
              </Table.Cell>
              <Table.Cell width={1}>
                <Input
                  transparent
                  size="small"
                  value={task.hours}
                  onKeyPress={(e) => {
                    if (e.key !== "0" && e.key !== "." && !parseFloat(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  error={isNaN(task.hours)}
                  onChange={(e) => {
                    this.updateTask("hours", index, e.target.value);
                  }}
                  onBlur={(e) => {
                    this.updateTask("hours", index, e.target.value);
                  }}
                  labelPosition="left"
                />
              </Table.Cell>
              <Table.Cell width={3}>
                <Dropdown
                  fluid
                  value={task.rateinfo}
                  placeholder="Rates"
                  search
                  options={this.props.rates}
                  onChange={(e, { value }) => {
                    let temptasks = this.state.estimate.tasks;
                    temptasks[index].rateinfo = value;
                    this.setState(
                      {
                        tasks: temptasks,
                      },
                      () => this.updateTask("rate", index, value.payrate)
                    );
                  }}
                />
              </Table.Cell>
              <Table.Cell width={1}>
                $ {Roundy(newtasks[index].rate * newtasks[index].hours)}
              </Table.Cell>
            </Table.Row>
          );
        }
      });
    }
  }
  updatenewtask(key, payload) {
    var newtask = {
      ...this.state.newtask,
      [key]: payload,
      number: this.state.estimate.tasks.length + 1,
    };
    newtask.subtotal = Roundy(
      parseFloat(newtask.hours) * parseFloat(newtask.rate)
    );
    this.setState({
      newtask,
    });
  }
  updatenewDeliv(key, payload) {
    var newdeliverable = {
      ...this.state.newdeliverable,
      [key]: payload,
      number: this.state.estimate.tasks.length + 1,
    };

    this.setState({
      newdeliverable,
    });
  }
  newtasklabel() {
    if (this.state.taskadd) {
      return (
        <Table.Row>
          <Table.Cell colSpan="5" active textAlign="center">
            Create New Task
          </Table.Cell>
        </Table.Row>
      );
    }
  }
  addTaskButton() {
    if (this.state.taskadd) {
      let task = this.state.newtask;
      return (
        <Button
          size="small"
          disabled={
            !task.subtotal ||
            task.subtotal === "NaN" ||
            !task.description ||
            !task.description.length
          }
          onClick={() => this.handletaskenter(task)}
          color="green"
        >
          <Icon name="plus square" /> Add To Tasks
        </Button>
      );
    }
  }
  addDelivButton() {
    if (this.state.delivadd) {
      let deliv = this.state.newdeliverable;
      console.log("description", deliv.description);
      return (
        <Button
          size="small"
          disabled={
            !deliv.description ||
            !deliv.description.length ||
            (!deliv.date && deliv.datereq)
          }
          onClick={() => this.handledeliventer(deliv)}
          color="green"
        >
          <Icon name="plus square" /> Add To Deliverables
        </Button>
      );
    }
  }
  wodbutton() {
    if (this.props.existing_estimate) {
      return (
        <Button
          size="small"
          onClick={() =>
            hashHistory.push("/work-orders/" + this.props.estimate.workOrderNbr)
          }
          color="blue"
        >
          Work Order
          <Icon name="arrow right" />
        </Button>
      );
    } else {
      return (
        <Button
          size="small"
          onClick={() => this.props.delete_estimate()}
          color="red"
        >
          Delete Estimate
        </Button>
      );
    }
  }
  populateState() {
    if (
      this.props.currentinfo &&
      this.props.currentinfo.program &&
      this.state.estimate.creator === "" &&
      this.props.myinfo
    ) {
      console.log("Mounting component")
      if (window.localStorage.getItem("newEstimate")) {
        this.setState({ estimate: JSON.parse(window.localStorage.getItem("newestimate")) })
      }

      let newestimate = {
        ...JSON.parse(window.localStorage.getItem("newEstimate")),
        creator: this.props.myinfo.lastname + " " + this.props.myinfo.firstname,
        projmanager: this.props.currentinfo.pminfo.contactname,
        program: this.props.currentinfo.program.program,
      };
      this.setState({
        estimate: newestimate,
      }, () => this.saveEstimate());

    } else if (this.props.estimate && !this.state.estimate.total) {
      this.setState({
        estimate: this.props.estimate,
      });
    }
  }
  updateDeliverable(index, key, value) {
    let tempdelivs = Array.from(this.state.estimate.deliverables);
    let tempdeliv = tempdelivs[index];
    //console.log('updating task', tempdeliv);
    tempdeliv = {
      ...tempdelivs[index],
      [key]: value,
    };
    tempdelivs[index] = tempdeliv;
    this.setState({
      estimate: {
        ...this.state.estimate,
        deliverables: tempdelivs,
      },
    }, () => this.saveEstimate());
  }
  gendeliv() {
    if (this.state.estimate.deliverables.length > 0) {
      return this.state.estimate.deliverables.map((deliv, index) => {
        if (this.state.delivadd) {
          return (
            <Table.Row>
              <Table.Cell width={1}> {deliv.item} </Table.Cell>
              <Table.Cell width={4}>
                <Input
                  ref="newdesc"
                  transparent
                  fluid
                  size="small"
                  value={deliv.description}
                  onChange={(e) => {
                    this.updateDeliverable(
                      index,
                      "description",
                      e.target.value
                    );
                  }}
                />
              </Table.Cell>
              <Table.Cell width={1}>
                <Input
                  transparent
                  fluid
                  type="date"
                  size="small"
                  value={deliv.date}
                  onChange={(e) =>
                    this.updateDeliverable(
                      index,
                      "date",
                      moment(e.target.value).format("YYYY-MM-DD")
                    )
                  }
                  labelPosition="left"
                />
              </Table.Cell>
              <Table.Cell width={1}>
                <Checkbox
                  toggle
                  checked={deliv.daterequired}
                  onChange={(e) =>
                    this.updateDeliverable(
                      index,
                      "daterequired",
                      deliv.daterequired ? false : true
                    )
                  }
                />
              </Table.Cell>
            </Table.Row>
          );
        } else {
          return (
            <Table.Row>
              <Table.Cell width={1}> {deliv.item} </Table.Cell>
              <Table.Cell width={6}> {deliv.description} </Table.Cell>
              <Table.Cell width={1}> {deliv.date} </Table.Cell>
              <Table.Cell width={1}>
                {deliv.daterequired ? "Yes" : "No"}
              </Table.Cell>
            </Table.Row>
          );
        }
      });
    }
  }
  newdelivlabel() {
    if (this.state.delivadd) {
      return (
        <Table.Row>
          <Table.Cell colSpan="4" active textAlign="center">
            Create New Deliverable
          </Table.Cell>
        </Table.Row>
      );
    }
  }
  gennewtask() {
    if (this.state.taskadd) {
      return (
        <Table.Row>
          <Table.Cell width={1}>
            {this.state.estimate.tasks.length + 1}
          </Table.Cell>
          <Table.Cell width={4}>
            <Input
              ref="newdesc"
              fluid
              size="small"
              value={this.state.newtask.description}
              onChange={(e) => {
                this.updatenewtask("description", e.target.value);
              }}
            />
          </Table.Cell>
          <Table.Cell width={1}>
            <Input
              size="small"
              // type="number"
              value={this.state.newtask.hours}
              onKeyPress={(e) => {
                if (e.key !== "0" && e.key !== "." && !parseFloat(e.key)) {
                  e.preventDefault();
                }
              }}
              onChange={(e) =>
                this.setState({
                  newtask: { ...this.state.newtask, hours: e.target.value },
                }, () => this.saveEstimate())
              }
              error={isNaN(this.state.newtask.hours)}
              onBlur={(e) => {
                this.updatenewtask("hours", Roundy(parseFloat(e.target.value)));
              }}
              labelPosition="left"
            />
          </Table.Cell>
          <Table.Cell width={3}>
            <Dropdown
              fluid
              placeholder="Rates"
              search
              options={this.props.rates}
              value={this.state.newtask.rateinfo}
              onChange={(e, { value }) => {
                let newtask = {
                  ...this.state.newtask,
                };
                newtask.rate = value.payrate;
                newtask.rateinfo = value;
                newtask.subtotal = Roundy(
                  parseFloat(newtask.rate) * parseFloat(newtask.hours)
                );
                this.setState({
                  newtask,
                });
              }}
            />
          </Table.Cell>
          <Table.Cell width={1}>
            $
            {this.state.newtask.subtotal &&
              this.state.newtask.subtotal !== "NaN"
              ? this.state.newtask.subtotal
              : "-"}
          </Table.Cell>
        </Table.Row>
      );
    }
  }
  gennewdeliv() {
    if (this.state.delivadd === true) {
      return (
        <Table.Row>
          <Table.Cell width={1}>
            {this.state.estimate.deliverables.length + 1}
          </Table.Cell>
          <Table.Cell width={6}>
            <Input
              ref="newdeliv"
              fluid
              size="small"
              value={this.state.newdeliverable.description}
              onChange={(e) =>
                this.updatenewDeliv("description", e.target.value)
              }
            />
          </Table.Cell>
          <Table.Cell width={1}>
            <Input
              fluid
              type="date"
              size="small"
              value={this.state.newdeliverable.date}
              onChange={(e) =>
                this.updatenewDeliv(
                  "date",
                  moment(e.target.value).format("YYYY-MM-DD")
                )
              }
              labelPosition="left"
            />
          </Table.Cell>
          <Table.Cell width={1}>
            <Checkbox
              toggle
              checked={this.state.newdeliverable.daterequired}
              onChange={(e) =>
                this.updatenewDeliv(
                  "daterequired",
                  this.state.newdeliverable.daterequired ? false : true
                )
              }
            />
          </Table.Cell>
        </Table.Row>
      );
    }
  }
  handletaskenter(newtask) {
    newtask = {
      ...newtask,
      item: this.state.estimate.tasks.length + 1,
    };
    let newtasks = this.state.estimate.tasks;
    newtasks.push(newtask);
    let newtotal = newtasks.reduce((a, b) => a + parseFloat(b.subtotal), 0);

    this.setState({
      estimate: {
        ...this.state.estimate,
        tasks: newtasks,
        total: newtotal,
      },
      newtask: {
        description: "",
        hours: 0,
      },
    }, () => this.saveEstimate());
    this.refs.newdesc.focus();
  }
  handledeliventer(newdeliv) {
    newdeliv = {
      ...newdeliv,
      item: this.state.estimate.deliverables.length + 1,
    };
    let newdelivs = this.state.estimate.deliverables.concat(newdeliv);
    this.setState({
      estimate: {
        ...this.state.estimate,
        deliverables: newdelivs,
      },
      newdeliverable: {
        description: "",
        date: null,
      },
    }, () => this.saveEstimate());
    this.refs.newdeliv.focus();
  }

  handleEdit(param, value) {
    // console.log("estimate param", param, "editmode:", this.state.editmode);
    if (this.state.editmode || this.props.create || !this.state.approval) {
      let newEstimate = {
        ...this.state.estimate,
        [param]: value,
      };
      this.setState(
        {
          estimate: newEstimate,
        }
        , () => this.saveEstimate()
      );
    }
  }

  render() {
    console.log("tminvparams", this.props.tminvparams)
    return (
      <Grid id="estimator">
        <Grid.Column width={12}>
          <Container>
            <Image
              src={require("./custPrintLetterhead.png")}
              centered
              id="logotext"
            />
            <Header as="h3" textAlign="center">
              Statement of Work
            </Header>
            <Table structured compact>
              <Table.Body>
                <Table.Row>
                  <Table.Cell width={1} inline singleLine>
                    Written For:
                  </Table.Cell>
                  <Table.Cell width={6} textAlign="left">
                    <Input
                      autoHeight
                      transparent
                      fluid
                      size="small"
                      value={this.state.estimate.projmanager}
                      onChange={(e) =>
                        this.handleEdit("projmanager", e.target.value)
                      }
                    />
                  </Table.Cell>
                  <Table.Cell width={1}> Status: </Table.Cell>
                  <Table.Cell textAlign="left" width={6}>
                    <Input
                      transparent
                      size="small"
                      fluid
                      value={this.state.estimate.status}
                      onChange={(e) =>
                        this.handleEdit("status", e.target.value)
                      }
                    />
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell width={1} inline>
                    By:
                  </Table.Cell>
                  <Table.Cell width={6} textAlign="left">
                    <Input
                      transparent
                      fluid
                      size="small"
                      value={
                        this.props.employee
                          ? this.props.employee.firstname +
                          " " +
                          this.props.employee.lastname
                          : this.state.estimate.creator
                      }
                      onChange={(e) =>
                        this.handleEdit("writtenby", e.target.value)
                      }
                      labelPosition="left"
                    />
                  </Table.Cell>
                  <Table.Cell width={1}> Description: </Table.Cell>
                  <Table.Cell textAlign="left" width={6}>
                    <Input
                      transparent
                      fluid
                      size="small"
                      value={this.state.estimate.description}
                      onChange={(e) =>
                        this.handleEdit("description", e.target.value)
                      }
                      labelPosition="left"
                    />
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell width={1} inline>
                    Date:
                  </Table.Cell>
                  <Table.Cell width={6} textAlign="left">
                    <Input
                      transparent
                      fluid
                      size="small"
                      value={moment(this.state.estimate.createDate).format(
                        "MM/DD/YYYY"
                      )}
                      onChange={(e) => this.handleEdit("date", e.target.value)}
                      labelPosition="left"
                    />
                  </Table.Cell>
                  <Table.Cell width={1}> SoW#: </Table.Cell>
                  <Table.Cell textAlign="left" width={6}>
                    <Input
                      transparent
                      fluid
                      size="small"
                      value={this.state.estimate.sowNumber}
                      onChange={(e) =>
                        this.handleEdit("sowNumber", e.target.value)
                      }
                      labelPosition="left"
                    />
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell width={1} inline>
                    EDF#:
                  </Table.Cell>
                  <Table.Cell width={6} textAlign="left">
                    <Input
                      transparent
                      fluid
                      inline
                      size="small"
                      value={
                        this.props.estimate && this.props.existing_estimate
                          ? this.props.estimate.workOrderNbr
                          : this.props.tminvparams.nextwonumber
                      }
                      labelPosition="left"
                    />
                  </Table.Cell>
                  <Table.Cell width={1}> PO#: </Table.Cell>
                  <Table.Cell textAlign="left" width={6}>
                    <Input
                      transparent
                      fluid
                      size="small"
                      value={this.state.estimate.poNumber}
                      onChange={(e) =>
                        this.handleEdit("poNumber", e.target.value)
                      }
                      labelPosition="left"
                    />
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell width={1} inline>
                    Project:
                  </Table.Cell>
                  <Table.Cell width={6} textAlign="left">
                    <Input
                      transparent
                      fluid
                      size="small"
                      value={this.state.estimate.program}
                      onChange={(e) =>
                        this.handleEdit("program", e.target.value)
                      }
                      labelPosition="left"
                    />
                  </Table.Cell>
                  <Table.Cell singleLine width={1}>
                    PO Item:
                  </Table.Cell>
                  <Table.Cell textAlign="left" width={6}>
                    <Input
                      transparent
                      fluid
                      size="small"
                      value={this.state.estimate.poItemNumber}
                      onChange={(e) =>
                        this.handleEdit("poItemNumber", e.target.value)
                      }
                      labelPosition="left"
                    />
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
            <Form>
              <Form.Group widths="equal">
                <Form.Field
                  label="Scope Of Work:"
                  onChange={(e) =>
                    this.handleEdit("scopeOfWorkSummary", e.target.value)
                  }
                  value={this.state.estimate.scopeOfWorkSummary}
                  control="textarea"
                  rows="4"
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  label="Standard Work Documents:"
                  value={this.state.estimate.standardWork}
                  onChange={(e) =>
                    this.handleEdit("standardWork", e.target.value)
                  }
                  control="textarea"
                  rows="1"
                />
              </Form.Group>
            </Form>
            <Table celled structured compact>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell colSpan="5"> Tasks </Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                  <Table.HeaderCell width={1}> Task# </Table.HeaderCell>
                  <Table.HeaderCell width={6}>
                    Task Description
                  </Table.HeaderCell>
                  <Table.HeaderCell width={1}> Hours </Table.HeaderCell>
                  <Table.HeaderCell width={1}> Rate </Table.HeaderCell>
                  <Table.HeaderCell width={1}> Subtotal </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {this.gentask()} {this.newtasklabel()} {this.gennewtask()}
              </Table.Body>
              <Table.Footer fullWidth>
                <Table.Row>
                  <Table.HeaderCell colSpan="2">
                    <Button
                      icon
                      primary
                      size="small"
                      disabled={this.props.approval}
                      onClick={() => {
                        this.setState({
                          taskadd: !this.state.taskadd,
                        });
                      }}
                    >
                      {this.state.taskadd ? "Collapse" : "Modify"}
                      <Icon
                        name={this.state.taskadd ? "angle up" : "angle down"}
                      />
                    </Button>
                    {this.addTaskButton()} {this.gendeletebutton()}
                  </Table.HeaderCell>
                  <Table.HeaderCell> {this.gentotalhours()} </Table.HeaderCell>
                  <Table.HeaderCell> Total: </Table.HeaderCell>
                  <Table.HeaderCell> $ {this.gensubtotal()} </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>
            </Table>
            <Table celled structured compact>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell colSpan="4">Deliverables</Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                  <Table.HeaderCell singleLine width={1}>
                    Deliverable#
                  </Table.HeaderCell>
                  <Table.HeaderCell width={6}>
                    Deliverable Description
                  </Table.HeaderCell>
                  <Table.HeaderCell width={1}> Date </Table.HeaderCell>
                  <Table.HeaderCell width={1}> Date Required </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body celled>
                {this.gendeliv()} {this.newdelivlabel()} {this.gennewdeliv()}
              </Table.Body>
              <Table.Footer fullWidth>
                <Table.Row>
                  <Table.HeaderCell colSpan="4">
                    <Button
                      icon
                      primary
                      disabled={this.props.approval}
                      size="small"
                      onClick={() => {
                        this.setState({
                          delivadd: !this.state.delivadd,
                        });
                      }}
                    >
                      {this.state.delivadd ? "Collapse" : "Modify"}
                      <Icon
                        name={this.state.delivadd ? "angle up" : "angle down"}
                      />
                    </Button>
                    {this.addDelivButton()} {this.gendeletedelivbutton()}
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>
            </Table>
            {this.handlesavebtn()} {this.geneditcheck()}
          </Container>
        </Grid.Column>
      </Grid>
    );
  }
}
export default Estimator;



// WEBPACK FOOTER //
// ./src/components/estimates/estimator.js